// Dependency-free runtime byte caps for the spatial decode module (A11/CD2). EAGER-safe: the
// header sniffer imports this (for MAX_SNIFF_WALK_BYTES) WITHOUT pulling any decoder, wkx, proj4,
// or maplibre. Keep this file constants-only — never add logic or imports here.

/** Grids, maps, anything decoded automatically. Values above this get a header-only summary. */
export const MAX_EAGER_DECODE_BYTES = 5 * 1024 * 1024;

/** Explicit user views (peek "Load full geometry", expanded dialog, compare). Above this the
 * surface shows a terminal "Too large to view (N MB)" state — there is NO larger ceiling (B38/CD7). */
export const MAX_ONDEMAND_DECODE_BYTES = 64 * 1024 * 1024;

/** The EAGER count-only sniff-walk cap (A6/NG2), SEPARATE from the 5 MB decode cap. Beyond it the
 * sniffer returns header facts only (pointCount: null) so a window of multiple ~4.9 MB values never
 * stalls the grid. */
export const MAX_SNIFF_WALK_BYTES = 256 * 1024;
